import type { InvoiceFileByIdParams, InvoiceFileByIdResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

/**
 * Downloads one invoice document by its file-row identifier.
 *
 * @param params - Invoice and file-row identifiers.
 * @param options - Additional request options.
 * @returns File contents as a Blob.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/get_invoice_file_by_id_invoices__invoice_id__file__file_id__get
 */
export function fetchInvoiceFileById(
  { fileId, invoiceId }: InvoiceFileByIdParams,
  options?: KyRequestOptions,
): Promise<InvoiceFileByIdResponse> {
  // Blob responses are not JSON and therefore have no Zod response schema.
  return vestigasApi
    .get(ENDPOINT.INVOICE.GET_FILE_BY_ID(invoiceId, fileId), options)
    .blob();
}
